module.exports = __webpack_public_path__ + "img/five.38fae1ec.png";